import { ACTIVITY_TAXONOMY_SELECTION_LIST_KEYS } from '../../../../shared/selection-lists/types';
import { defineTreeFilter } from '../engine/descriptor';
import type { FilterDefinition } from '../engine/types';
import { FilterId, FilterType, type TreeFilter } from '../types/filters';

export const activityDescriptor = defineTreeFilter({
  definition: {
    id: FilterId.ACTIVITY,
    name: 'Activity',
    selectionListIds: [...ACTIVITY_TAXONOMY_SELECTION_LIST_KEYS],
    selections: [],
    type: FilterType.TREE,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_ACTIVITY },
  handler: { getRequiredSelectionListIds: () => [] },
});

export const activityDefinition: FilterDefinition<TreeFilter> =
  activityDescriptor.definition;
